import ExpandableText from '../common/ExpandableText';
import Table from '../common/Table';

const renderExpandableCell = (params) => {
    return (
        <ExpandableText
            text={params.value || ''}
            width={params.colDef.computedWidth}
            isHeader={false}
        />
    );
};

const renderExpandableHeader = (params) => {
    return (
        <ExpandableText
            text={params.colDef.headerName}
            width={params.colDef.computedWidth}
            isHeader={true}
        />
    );
};

const SingleWorkOrderTable = (props) => {
    const {workOrder} = props;

    const cellStyling = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center', 
        textAlign: 'center',
    };

    const headerStyling = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: "#F2F3F4",
        fontFamily: "Roboto",
        textAlign: "center",
    };

    const sx = {
        '& .MuiDataGrid-cell': cellStyling,
        '& .MuiDataGrid-columnHeader': headerStyling,
        '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
        },
    };

    return (
        <div>
            <div className="Single-Vehicle-Table">
                <Table
                    columns={[
                        {
                            headerName: "Service Date",
                            headerAlign: 'center',
                            field: "serviceDate",
                            flex: 0.8,
                            sortable: false,
                        },
                        {
                            headerName: "Work Order #",
                            headerAlign: 'center',
                            field: "workOrderId",
                            flex: 1,
                            sortable: false,
                        },
                        {
                            headerName: "Customer Name",
                            headerAlign: 'center',
                            field: "customer",
                            flex: 1,
                            sortable: false,
                            renderCell: renderExpandableCell,
                            renderHeader: renderExpandableHeader,
                        },
                        {
                            headerName: "Vehicle Year / Make / Model",
                            headerAlign: 'center',
                            field: "vehicle",
                            flex: 2,
                            sortable: false,
                            renderCell: renderExpandableCell,
                            renderHeader: renderExpandableHeader,
                        },
                        {
                            headerName: "License Plate",
                            headerAlign: 'center',
                            align: 'center',
                            field: "license",
                            flex: 0.8,
                            sortable: false,
                        },
                    ]}
                    data={[workOrder]}
                    sx={sx}
                    key={"SafetyPrint-WO-Table"}
                />
            </div>
        </div>
    );
}

export default SingleWorkOrderTable;